import { render, staticRenderFns } from "./listados_cerradoComponent.vue?vue&type=template&id=01d7833c&"
import script from "./listados_cerradoComponent.vue?vue&type=script&lang=js&"
export * from "./listados_cerradoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports